import { IconProps } from ".";
import Icon from "./assets/doc_downloaded_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon20DocDownloaded(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} className="text-[20px]" />;
}
